// import { LocationsList } from "components/Locations";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { LocationsList } from "../../components/LocationsList";


export interface ILocationsListPage {}

export const LocationsListPage: FC<ILocationsListPage> = (
  props: ILocationsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Locations List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Locations", navigateTo: "/company/locations/list" },
      ]}
      mainContents={<LocationsList />}
    />
  );
};
